import { gql } from "urql";
export const GetPublicOrganizationDetailsQuery = gql `
    query GetPublicOrganizationDetails($organizationId: String!) {
        organizations {
            publicOrganizationDetails(organizationId: $organizationId) {
                organizationId
                name
                imageUrl
            }
        }
    }
`;
